import { useState } from 'react';
import { CheckIcon, CopyIcon } from '@phosphor-icons/react';
import toast from 'react-hot-toast';

import { Dialog } from 'components/dialog/Dialog';
import { Button } from 'components/button/Button';

export interface CreatedKeyDialogLabels {
  title: string;
  warning: string;
  copyButton: string;
  copiedToast: string;
}

export interface CreatedKeyDialogProps {
  fullKey: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  labels: CreatedKeyDialogLabels;
}

export const CreatedKeyDialog: React.FC<CreatedKeyDialogProps> = ({ fullKey, open, onOpenChange, labels }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await globalThis.window.navigator.clipboard.writeText(fullKey);
      setCopied(true);
      toast.success(labels.copiedToast);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Failed to copy to clipboard');
    }
  };

  return (
    <Dialog isOpen={open} onClose={() => onOpenChange(false)} title={labels.title}>
      <div className="mb-4">
        <p className="text-sm text-negative-text font-medium mb-2">{labels.warning}</p>
        <div className="flex items-center gap-2">
          <code className="flex-1 rounded border border-border bg-neutral-subtle px-3 py-2 text-sm font-mono break-all">
            {fullKey}
          </code>
          <Button
            color="secondary"
            onTrigger={handleCopy}
            iconLeft={copied ? <CheckIcon className="button-icon" /> : <CopyIcon className="button-icon" />}
          >
            {labels.copyButton}
          </Button>
        </div>
      </div>

      <div className="flex justify-end">
        <Button color="primary" onTrigger={() => onOpenChange(false)}>
          OK
        </Button>
      </div>
    </Dialog>
  );
};
